import { createColumnDate, createColumnInput, createColumnSelect } from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import { putField } from "../../../../utils/form";
import { callDocumentStatus } from "../../storage-location/storage-location/storage-location.section";
import { callUserObjective } from "../request/request.section";

export const createColumns = () => {
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("model.haz.refUserCompany"),
            dataIndex: "refUserCompany.companyNameTh",
            dataIndexValue: ({ record }) =>
                record.refUserCompany?.refPersonType?.key === "1" ? record.refUserCompany?.companyNameTh : record.refUserCompany?.fullNameTh,
            customRender: ({ record, column }) => column.dataIndexValue({ record })
        }),
        createColumnInput({ title: () => i18n.global.t("views.request.approveCode"), dataIndex: "approveCode", align: "center" }),
        createColumnDate({ title: () => i18n.global.t("model.haz.expireDate"), dataIndex: "expireDate", align: "center" }),
        createColumnInput({
            title: () => i18n.global.t("model.hazLicense.refHaz"),
            dataIndexValue: ({ record }) => record?.hazLicenseDetails?.map(itemName => itemName.refHaz.approveCode).join(', '),
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "center",
            search: { name: "hazLicenseDetails.refHaz.approveCode" }
        }),
        createColumnInput({
            title: () => i18n.global.t("model.hazLicense.refHazName"),
            dataIndexValue: ({ record }) => record?.hazLicenseDetails?.map(itemName => itemName.refHaz.refHazObject.nameTh).join(', '),
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "center",
            search: { visible: () => false }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.haz.refOperation"),
            dataIndex: "refOperation.value",
            inputProp: () => ({ list: callUserObjective, optLabel: "value" }),
            search: { name: "refOperation.id" }
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.haz.refStatus"),
            dataIndex: "refStatus.value",
            inputProp: () => ({ list: callDocumentStatus, optLabel: "value" }),
            search: { name: "refStatus.id" },
            align: "center"
        })
    ];
    return columns;
};

export const createField = ({ data }) => {
    return putField({
        data,
        fields: []
    });
};
